import { memo } from "react";

import cls from "./Loader.module.scss";
import { classNames } from "shared/lib/classNames/classNames";

export type LoaderSize = "small" | "middle" | "big";
export type LoaderVariant = "normal" | "white";

interface LoaderProps {
    className?: string;
    size?: LoaderSize;
    variant?: LoaderVariant;
}

export const Loader = memo((props: LoaderProps) => {
    const { className, size = "middle", variant = "normal" } = props;

    return <span className={classNames(cls.loader, {}, [className, cls[size], cls[variant]])}></span>;
});
Loader.displayName = "Loader";
